import { LongMarkerPosition } from './Maps'
import { Moment } from 'moment'

export enum TrackingUserStatus {
  OFFLINE = 0,
  ONLINE = 1,
  INACTIVE = 2
}

export enum TrackingUserActivityType {
  STILL = 'still',
  WALKING = 'walking',
  ON_FOOT = 'on_foot',
  RUNNING = 'running',
  ON_BICYCLE = 'on_bicycle',
  IN_VEHICLE = 'in_vehicle'
}

export enum TrackingUserTaskLocationStatus {
  UNCOMPLETE = 0,
  COMPLETE = 1,
  COMPLETE_WARN = 2
}

export enum TrackingUserChangeType {
  POSITION = 1,
  INFO = 2
}

export enum LocationStatusFills {
  IN_SITE = 'in-site',
  OUT_OF_SITE = 'out-of-site',
  NOT_WORKED = 'not-worked'
}

export class TrackingUserGroup {
  id: number
  name: string
  subGroups: TrackingUserGroup[]
}

export class TrackingUserDevice {
  id: number
  imei: string
  uuid: string
  creationDate: number
  updateDate: number
  status: string
  device: string
}

export abstract class TrackingUserPositionAbstract {
  version: number
  _timestamp: Moment
}

export class TrackingUserPosition extends TrackingUserPositionAbstract {
  accuracy: number
  altitude: number
  dateReceiveFB: number
  device: string
  imei: string
  uuid: string
  isMainAppVisible: boolean
  provider: string
  position: string
  time: string

  // Extra info (other versions)
  speed: number
  heading: number
  event: any
  mock: boolean
  odometer: number
  isMoving: boolean
  activityType: TrackingUserActivityType
  activityUnconfidence: number
  activityConfidence: number
  batteryIsCharging: boolean
  batteryLevel: number

  _gpsOn: boolean
}

export class TrackingUser {
  id: number
  name: string
  firstName: string
  lastName: string
  device: TrackingUserDevice

  position: TrackingUserPosition
  status: TrackingUserStatus

  mockGps: boolean
  batteryIsCharging: boolean
  batteryLevel: number
  activityType: TrackingUserActivityType
  activityConfidence: number

  groups: TrackingUserGroup[]

  _lastTimeConnected: Moment
  _lastPositionKey: number
}

export class TrackingUserTaskIdent {
  name: string
  label: string
  value: string
}

export class TrackingUserTask {
  id: number
  user: string
  templateId: number
  fillName: string
  fillLocation: LongMarkerPosition
  plannedLocation: LongMarkerPosition
  visitedLocation: LongMarkerPosition
  locationStatus: string
  working: string
  receivedDate: number
  ident0: TrackingUserTaskIdent
  ident1: TrackingUserTaskIdent
  ident2: TrackingUserTaskIdent
  fullIdent: string = ''
  status: TrackingUserTaskLocationStatus
}

export class TrackingUserTasksFilters {
  templateId: number
  userId: number
  user: TrackingUser
  altUser: TrackingUser
  initDate: Date
  endDate: Date
  worked: boolean
  last: boolean
  locationStatus: LocationStatusFills[]
}

export class PageRequestTrackingFilters {
  onlyActiveUsers: boolean
  onlyMobileUsers: boolean
  from: number
  to: number
}

export class PageRequestTrackingUserSession {
  user: number
}

export class TrackingUserInfotmation {
  name: string
  firstName: string
  lastName: string
}

export class TrackingUserSession {
  active: boolean
  acquiredDate: number
  releaseDate?: number
}
